'use client'

import { usePathname } from 'next/navigation'
import I18nProvider from '@/providers/I18nProvider'
import QueryProvider from '@/providers/QueryProvider'
import ThemeProvider from '@/providers/ThemeProvider'

type Props = {
  children: React.ReactNode
}

const Providers = ({ children }: Props) => {
  const pathname = usePathname()
  const isBrandPage = ['/', '/peacecover', '/ko', '/ja'].includes(pathname.replace(/\/$/, '') || '/')
  return (
    <ThemeProvider>
      <QueryProvider>
        {isBrandPage ? children : <I18nProvider>{children}</I18nProvider>}
      </QueryProvider>
    </ThemeProvider>
  )
}
export default Providers
